import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export const fetchDashboardFlags = createAsyncThunk(
  "dashboardFrame/fetchDashboardFlags",
  async (_, { getState }) => {
    const state = getState();
    const license_key = state.authen.loggedInUser.license_key;
    const { data } = await axios.post(
      `${baseURL}/emis_pathology/api/dashboard_flags`,
      { license_key },
    );
    return data;
  },
);

export const fetchLineChartData = createAsyncThunk(
  "dashboardFrame/fetchLineChartData",
  async ({ start, end }, { getState }) => {
    const state = getState();
    const license_key = state.authen.loggedInUser.license_key;
    const payload = { license_key, start, end };
    const { data } = await axios.post(
      `${baseURL}/emis_pathology/api/dashboard_chart`,
      payload,
    );
    return data;
  },
);

const initialState = {
  flags: [],
  chartData: [],
  loadingFlags: false,
  loadingChart: false,
  error: null,
};

const dashboardFrameSlice = createSlice({
  name: "dashboardFrame",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Flags
      .addCase(fetchDashboardFlags.pending, (state) => {
        state.loadingFlags = true;
      })
      .addCase(fetchDashboardFlags.fulfilled, (state, action) => {
        state.flags = action.payload;
        state.loadingFlags = false;
      })
      .addCase(fetchDashboardFlags.rejected, (state, action) => {
        state.loadingFlags = false;
        state.error = action.error.message;
      })

      // Chart
      .addCase(fetchLineChartData.pending, (state) => {
        state.loadingChart = true;
      })
      .addCase(fetchLineChartData.fulfilled, (state, action) => {
        state.chartData = action.payload;
        state.loadingChart = false;
      })
      .addCase(fetchLineChartData.rejected, (state, action) => {
        state.loadingChart = false;
        state.error = action.error.message;
      });
  },
});

export default dashboardFrameSlice.reducer;
